export const SET_USER = 'SET_USER'
export const SET_CYCLE = 'SET_CYCLE'
export const SELECT_CYCLE = 'SELECT_CYCLE'
export const SELECT_CYCLE_YEAR = 'SELECT_CYCLE_YEAR'
export const SET_USERS = 'SET_USERS'
export const ADD_USERS = 'ADD_USERS'

export const SET_LANGUAGE = 'SET_LANGUAGE'
export const TOGGLE_SIDE_MENU_COLLAPSED = 'TOGGLE_SIDE_MENU_COLLAPSED'

export const CHECK_CONDITION = 'CHECK_CONDITION'
export const CHECK_GUIDE_STEP = 'CHECK_GUIDE_STEP'
export const CHECK_GUIDE_VERSION = 'CHECK_GUIDE_VERSION'

export const SET_MENU = 'SET_MENU'
